// Shared "does this intern already have a submitted LiKES evaluation?" logic.
// Used by the sidebar (to keep the survey entry visible after submission) and
// by the survey page itself, so the two can never drift apart.

// True only for a non-null object carrying at least one key. The backend may
// return `evaluation: {}` for "not submitted yet", which must not count.
export const hasEvaluationData = (evaluation) => {
  return (
    !!evaluation &&
    typeof evaluation === "object" &&
    !Array.isArray(evaluation) &&
    Object.keys(evaluation).length > 0
  );
};

// Reads the "already submitted" flag defensively: the exists/ contract is not
// observable from this repo, so several plausible field names are accepted and
// only an explicit `true` is treated as submitted.
const readSubmittedFlag = (existsData) => {
  return (
    existsData?.has_intern_evaluation ??
    existsData?.intern_evaluation_submitted ??
    existsData?.evaluation_submitted ??
    existsData?.is_evaluation_submitted
  );
};

// -> true      : the survey must be reachable (still required, or already submitted)
// -> false     : nothing indicates this person is part of LiKES at all
// -> "unknown" : the intern exists but the payload does not say whether a
//                survey was submitted; the caller must verify with real data
export const isLikesSurveyAccessible = (existsData) => {
  if (!existsData || typeof existsData !== "object") return false;

  if (readSubmittedFlag(existsData) === true) return true;

  if (existsData?.show_intern_evaluation === true) return true;

  if (existsData?.intern_id) return "unknown";

  return false;
};
